import { useAuthState } from '@creditornot/wolt-auth/react';
import { useQuery } from '@tanstack/react-query';

import { fetchEnterprisesForUser } from 'apis/enterprise/api';

export const useGetEnterprisesForUser = (isEnabled: boolean) => {
  const { user } = useAuthState();

  const { data: enterprises = [], isLoading } = useQuery(
    ['/v1/merchant-admin/enterprises'],
    () => {
      return fetchEnterprisesForUser();
    },
    {
      enabled: isEnabled && !!user,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
    },
  );

  return {
    isLoading,
    enterprises,
  };
};
